import { AgGridReact, AgGridReactProps } from 'ag-grid-react';

export type DataGridProps = AutoHeightGrid | FixedHeightGrid;

interface AutoHeightGrid extends AgGridReactProps {
  /**
   * Sets the height of the grid to match the number of rows inside the grid
   */
  domLayout: 'autoHeight';
  /**
   * Width of the grid container. Applied via inline style attribute.
   */
  width: React.CSSProperties['width'];
}

interface FixedHeightGrid extends AgGridReactProps {
  domLayout?: never;
  /**
   * Height of the grid container. Applied via inline style attribute.
   */
  height: React.CSSProperties['height'];
  /**
   * Width of the grid container. Applied via inline style attribute.
   */
  width: React.CSSProperties['width'];
}

/**
 * Grid component for displaying large sets of tabular data.
 * Implements ag-grid community edition with a tock specific theme.
 *
 * @see [Documentation](https://www.ag-grid.com/react-grid/)
 *
 * @deprecated Fine to use for Tock internal tools only. Please use `@tocktix/pantry` UI components for any new JCE admin tools.
 */
const DataGrid: React.FC<React.PropsWithChildren<DataGridProps>> = ({ defaultColDef, ...rest }) => {
  const gridSize =
    rest.domLayout === 'autoHeight'
      ? { width: rest.width }
      : { height: rest.height, width: rest.width };

  return (
    <div className="ag-theme-tock" style={gridSize}>
      <AgGridReact
        defaultColDef={{ resizable: false, sortable: false, ...defaultColDef }}
        suppressMovableColumns={true}
        enableCellTextSelection={true}
        ensureDomOrder={true}
        {...rest}
      />
    </div>
  );
};

export default DataGrid;
